<template>
     <Accordion title="Change Password" :isOpenInitially="true">
        <div>

            <div class="flex  gap-2">
            <!-- Current Password -->
            <div class="w-full">
                <label for="current_password" class="block text-sm font-medium text-gray-600 mb-1">Current Password</label>
                <Password
                id="current_password"
                v-model="form.current_password"
                :feedback="false"
                toggleMask
                 inputClass="w-full"
                placeholder="Enter your current password"
                class="w-full"
                />
            </div>

            <!-- New Password -->
            <div class="w-full">
                <label for="password" class="block text-sm font-medium text-gray-600 mb-1">New Password</label>
                <Password
                id="password"
                v-model="form.password"
                :feedback="true"
                toggleMask
                 inputClass="w-full"
                placeholder="Enter new password"
                class="w-full"
                />
            </div>

            <!-- Confirm Password -->
            <div class="w-full">
                <label for="password_confirmation" class="block text-sm font-medium text-gray-600 mb-1">Confirm Password</label>
                <Password
                id="password_confirmation"
                v-model="form.password_confirmation"
                :feedback="false"
                toggleMask
                 inputClass="w-full"
                placeholder="Confirm new password"
                class="w-full"
                />
            </div>

            </div>

             <Button
                label="Change Password"
                icon="pi pi-lock"
                class="w-full lg:w-64 mt-2"
                :loading="loading"
                size="small"
                @click="handleChangePassword"
                data-testid="btn-settings-password-save"
            />
        </div>

     </Accordion>

</template>

<script setup lang="ts">
import { useUserStore } from '@/store/userStore';
import { useAuthMutations } from '@/composables/mutations/auth/useAuthMutations';
import { useToast } from 'primevue/usetoast';
import Accordion from '../Utils/Accordion.vue';

const userStore = useUserStore();
const { changeUserPassword } = useAuthMutations();
const toast = useToast();

const loading = ref(false);

const form = ref({
  current_password: '',
  password: '',
  password_confirmation: '',
});

async function handleChangePassword() {
  if (!form.value.current_password || !form.value.password || !form.value.password_confirmation) {
    toast.add({ severity: 'warn', summary: 'Warning', detail: 'All fields are required.', life: 3000 });
    return;
  }

  if (form.value.password !== form.value.password_confirmation) {
    toast.add({ severity: 'warn', summary: 'Warning', detail: 'Passwords do not match.', life: 3000 });
    return;
  }

  loading.value = true;
  try {
    await changeUserPassword({
      current_password: form.value.current_password,
      password: form.value.password,
      password_confirmation: form.value.password_confirmation,
    });

    form.value.current_password = '';
    form.value.password = '';
    form.value.password_confirmation = '';
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : 'Failed to change password.';
    toast.add({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
  } finally {
    loading.value = false;
  }
}
</script>

<style scoped>
.p-password {
  width: 100%;
}
</style>
